import React, { useState } from 'react';
import styled from 'styled-components';
import { FormAnswer } from '../Form';
import theme from '../../../UI/theme';
import Button from '../../UiComponents/Button';
import { ButtonRowContainer } from '../../panel/ModalStyles';
import ProgressDots from '../ProgressDots';
import TextArea from '../../UiComponents/text/TextArea';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 30px;

    p {
        font-size: 1.2rem;
        color: ${theme.colors.textGray};
        text-align: center;
        font-weight: 600;
        margin-bottom: 0px;
    }

`



const MultilineAnswer = ({ form, questionDetails, nextQuestion, nextText, closable=true, close=() => {} , totalQuestions=null, currentQuestionNumber=null, isLastQuestion=false, placeholder='Please comment...'}) => {
    const [answer, setAnswer] = useState('');

    const submitAnswer = async () => {
        if (!answer) return nextQuestion();
        const answerObj = new FormAnswer(form, questionDetails.questionId, questionDetails.questionNumber, questionDetails.questionText, questionDetails.answerValueType);
        answerObj.setAnswerValue(answer);
        await answerObj.save();
        nextQuestion();
    }

    const onCloseHandler = async () => {
        if (closable) {
            await submitAnswer();
            close();
        }
    }

    return (
        <Container>
            {(totalQuestions && currentQuestionNumber) && <ProgressDots total={totalQuestions} current={currentQuestionNumber} />}
            <h2>{questionDetails.questionText}</h2>
            {questionDetails.questionSubtext && <p>{questionDetails.questionSubtext}</p>}
            {(totalQuestions && currentQuestionNumber) && <ProgressDots total={totalQuestions} current={currentQuestionNumber} />}
            <TextArea placeholder={placeholder} value={answer} onChange={(e) => setAnswer(e.target.value)} rows={5} />
            <ButtonRowContainer>
                <Button disabled={!answer && !isLastQuestion} primary onClick={submitAnswer} style={{marginTop: '20px'}}>{nextText || (isLastQuestion ? 'Submit' : 'Next')}</Button>
                {(closable && !isLastQuestion)&& <Button secondary onClick={onCloseHandler} style={{marginTop: '20px'}}>Close</Button>}
            </ButtonRowContainer>
            
        </Container>
    )
}

export default MultilineAnswer;